

















































































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface CollectionDetailTabBudgetItem {
  acceptDate: string // 日付
  orderDate: string // 日付
  listPrice: number
  donorCode: SystemCode
  budgetExpenseCode: SystemCode
  acceptType: SystemCode
  tempAcceptDate: string // 日付
  evaluationPrice: number
  budgetYear: number
  equipType: SystemCode
  acceptPrice: number
  orderPrice: number
  applicantUserId: string
  budgetBranchCode: SystemCode
  traderCode: SystemCode
  budgetDepartmentCode: SystemCode
}

export const defaultCollectionDetailTabBudgetItem = (): CollectionDetailTabBudgetItem => ({
  acceptDate: '', // 日付
  orderDate: '', // 日付
  listPrice: 0,
  donorCode: defaultSystemCode(),
  budgetExpenseCode: defaultSystemCode(),
  acceptType: defaultSystemCode(),
  tempAcceptDate: '', // 日付
  evaluationPrice: 0,
  budgetYear: 0,
  equipType: defaultSystemCode(),
  acceptPrice: 0,
  orderPrice: 0,
  applicantUserId: '',
  budgetBranchCode: defaultSystemCode(),
  traderCode: defaultSystemCode(),
  budgetDepartmentCode: defaultSystemCode()
})

@Component({
  components: {}
})
export default class CollectionDetailTabBudget extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabBudgetItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  get isCollection(): boolean {
    return !this.isOrder
  }

  get budgetYear(): string {
    return this.displayNumber(this.item.budgetYear)
  }

  get acceptPrice(): string {
    return this.isCollection ? this.displayPrice(this.item.acceptPrice) : ''
  }

  get evaluationPrice(): string {
    return this.isOrder ? this.displayPrice(this.item.evaluationPrice) : ''
  }

  get orderPrice(): string {
    return this.isOrder ? this.displayPrice(this.item.orderPrice) : ''
  }

  displayNumber(value: number): string {
    return value !== 0 ? String(value) : ''
  }

  displayPrice(value: number): string {
    return `￥${value.toLocaleString()}`
  }
}
